export const CERTIFICATE_LIST = [
  {
    title: 'Butler',
    image: 'Driver.jpeg',
    status: 'Join',
    desc: 'Helping others does not require any certificates but you can write up any prior experience you have to allow others to understand more about you. '
  },
  {
    title: 'Handyman',
    image: 'Handyman.jpeg',
    status: 'Join',
    desc: 'Library working on top of application and causing touch delay on this'

  },
  {
    title: 'Driver',
    image: 'Butler.jpeg',
    status: 'Join',
    desc: 'You must have a driver license to be able to provide this service. If you provide riding hailing services please do let us know too!'

  },
  {
    title: 'Cleaner',
    image: 'Cleaner.jpeg',
    status: 'Join',
    desc: 'You have to upload a brief summary of your cleaning experience and professional equipment you use to clean a home. '

  },
  {
    title: 'Teacher',
    image: 'Teacher.jpeg',
    status: 'Join',
    desc: 'Certificates are a requirement to be able to provide tuition services in your locale. '

  },
  {
    title: 'Chef',
    image: 'Chef.jpeg',
    status: 'Join',
    desc: 'Cert or no cert if you can whip up a tasty meal do write up the focus you are niche in.'

  },
  {
    title: 'Yoga',
    image: 'Yoga.jpeg',
    status: 'Join',
    desc: 'Library working on top of application and causing touch delay on this'

  },
  {
    title: 'Coach',
    image: 'Coach.jpeg',
    status: 'Join',
    desc: 'Short summary of your experience related to the type of sport you wish to coach. '

  },
  {
    title: 'Volunteer',
    image: 'Volunteer.jpeg',
    status: 'Join',
    desc: 'No experience is needed to become a volunteer but a short write up is appreciated so that we know what you prefer. '

  },
  {
    title: 'Writer',
    image: 'Writer.jpeg',
    status: 'Join',
    desc: 'Library working on top of application and causing touch delay on this'

  },
  {
    title: 'Pest Killer',
    image: 'man-1.jpeg',
    status: 'Join',
    desc: 'Library working on top of application and causing touch delay on this'

  },
  {
    title: 'Food Delivery',
    image: 'food-delivery.jpg',
    status: 'Join',
    desc: 'Library working on top of application and causing touch delay on this'
  },
  {
    title: 'Aircon Man',
    image: 'food-delivery.jpg',
    status: 'Join',
    desc: "An Aircon Man specializes in installing, maintaining, and repairing air conditioning systems for residential, commercial, and industrial spaces. They ensure that cooling units function efficiently, perform regular maintenance like cleaning filters, check refrigerant levels, and troubleshoot system failures. Their role also involves providing expert advice on energy-efficient systems to meet the client's needs."
  },
  {
    title: 'Furniture Assembler',
    image: 'food-delivery.jpg',
    status: 'Join',
    desc: "A Furniture Assembler is responsible for constructing, assembling, and installing furniture, including desks, chairs, beds, and cabinets. They work with both ready-to-assemble kits and custom-built pieces, ensuring all components are securely fitted. Their job requires precision, attention to detail, and the ability to follow instructions or blueprints to create durable and aesthetically pleasing furniture."
  }
]